'use strict';

/**
 * Must stay in sync with App\Services\PromotionModal\PromotionModalInputValidator::isValidEmailFormat
 * and tests/Unit/Services/PromotionModal/fixtures/email-format-contract.json.
 *
 * @param {string} email
 * @returns {boolean}
 */
export function isValidEmailFormat(email) {
	if (typeof email !== 'string') {
		return false;
	}

	const trimmed = email.trim();
	if (trimmed.length === 0 || trimmed.length > 128) {
		return false;
	}

	const atIndex = trimmed.indexOf('@');
	if (atIndex === -1 || atIndex === 0 || atIndex === trimmed.length - 1) {
		return false;
	}

	const localPart = trimmed.substring(0, atIndex);
	const domainPart = trimmed.substring(atIndex + 1);
	const localPartRegex = /^[a-zA-Z0-9._+-]+$/;
	if (!localPartRegex.test(localPart)) {
		return false;
	}

	if (localPart.startsWith('.') || localPart.endsWith('.') || localPart.startsWith('-') || localPart.endsWith('-')) {
		return false;
	}

	if (localPart.includes('..')) {
		return false;
	}

	if (domainPart.length === 0 || domainPart.startsWith('.') || !domainPart.includes('.')) {
		return false;
	}

	const lastDotIndex = domainPart.lastIndexOf('.');
	const tld = domainPart.substring(lastDotIndex + 1);
	if (tld.length < 2 || !/^[a-zA-Z0-9-]+$/.test(tld)) {
		return false;
	}

	const domainPartRegex = /^[a-zA-Z0-9.-]+$/;
	if (!domainPartRegex.test(domainPart) || domainPart.includes('..')) {
		return false;
	}

	return true;
}
